export default {
  enter: 'enter',
  reject: 'reject',
  switch: 'switch',
  preventSwitch: 'preventSwitch',
  wasOnWallet: 'wasOnWallet',
  savedOrders: 'savedOrders',
  deletedOrders: 'deletedOrders',
  didWidgetsDataSend: 'didWidgetsDataSend',
  activeTabId: 'activeTabId',
  testnetSkip: 'testnetSkip',
  storageRevision: '_revision',
  wasCautionPassed: 'wasCautionPassed',
  hiddenCoinsList: 'hiddenCoinsList',
  privateKeysSaved: 'privateKeysSaved',
  demoMoneyReceived: 'demoMoneyReceived',
  wasOnExchange: 'wasOnExchange',
  isWalletCreate: 'isWalletCreate',
  lastCheckBalance: 'lastCheckBalance',
  startSwap: 'startSwap',
  didProtectedBtcCreated: 'protectedBtcCreated',
  didPinBtcCreated: `${process.env.ENTRY}:pinBtcCreated`,
  didProtectedBtcG2FACreated: 'protectedBtcG2FA',
  walletTitle: 'walletTitle',
  customToken: 'customToken',
  balanceActiveCurrency: 'balanceActiveCurrency',
  signedUpWithPush: 'signedUpWithPush',
  backups: `${process.env.ENTRY}:backups`,
  backups_prefix: `${process.env.ENTRY}:backup:`,
  invoicesEnabled: `${process.env.ENTRY}:invoicesEnabled`,
  wasOnWidgetWallet: 'wasOnWidgetWallet',
  isDark: 'isDark',
  isLight: 'isLight',
  testnetSkipPKCheck: 'testnetSkipPKCheck',
  prevWPUser: 'wp_widget_prev_userid',
  exchangeSettings: 'exchangeSettings',
  extensionLastActivity: 'extensionLastActivity',
}
